import * as yup from "yup";

export const profileValidation = yup.object().shape({
  name: yup.string().required("Full name is required"),
  mobile: yup.string().required("Mobile number is required"),
});

export const validateEmail = (email) => {

  var validRegex = /^[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}$/;

  return email?.match(validRegex);

  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};